var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('w-btn',{attrs:{"color":"purple","loading":_vm.loading,"text":_vm.$t('common.unarchive'),"icon":"mdi-archive"},on:{"press":_vm.press}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }